import React from "react";
import styled from "styled-components";

const Divider = ({ children, marginVertical, toBottom, ...props }) => {
    return (
        <CDivider $marginVertical={marginVertical} $toBottom={toBottom} {...props}>
            {children}
        </CDivider>
    );
};

const getMarginTop = (toBottom, marginVertical) => {
    if (toBottom) {
        return "auto";
    }

    if (marginVertical || marginVertical === 0) {
        return `${marginVertical}px`;
    }

    return `32px`;
}

const getMarginBottom = (toBottom, marginVertical) => {
    if (toBottom) {
        return `32px`;
    }

    if (marginVertical || marginVertical === 0) {
        return `${marginVertical}px`;
    }

    return `32px`;
}

const CDivider = styled.div`
  border-bottom: 1px solid var(--aia-bx-grey-20);
  padding: ${props => props.$toBottom ? "16px" : "0px"};
  margin-top: ${props => getMarginTop(props.$toBottom, props.$marginVertical)};
  margin-bottom: ${props => getMarginBottom(props.$toBottom, props.$marginVertical)};
`;

CDivider.defaultProps = {
    $marginVertical: undefined,
    $toBottom: undefined,
}

export default Divider;